import { render, staticRenderFns } from "./File.vue?vue&type=template&id=4fc4b31a&scoped=true"
import script from "./File.vue?vue&type=script&lang=ts"
export * from "./File.vue?vue&type=script&lang=ts"
import style0 from "./File.vue?vue&type=style&index=0&id=4fc4b31a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc4b31a",
  null
  
)

export default component.exports